import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AddProduct from '../../common/products/addProduct';
import no_img from '../../../assets/no_image.jpg';
import Carousel, { Dots } from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';
import {
  formatNumber,
  hasAvailableStock,
  priceDiscount,
  priceDiscountValue,
} from '../../../middleware/common-functions';
import { Sharebutton } from '../../common/buttons';
import mplogo from '../../../assets/MP_RGB_HANDSHAKE_color_notext.png';
import PhoneIllustration from '../../../assets/PhoneIllustration';
import { db } from '../../../middleware/firebase';

const Images = ({ alt, images, videos, handleImage, active_image }) => {
  if (!images || images.length < 1) {
    return (
      <div className="images">
        <img src={no_img} alt={alt} className="img-fluid" />
      </div>
    );
  }
  const slides = images.map((image_url, key) => (
    <img
      src={image_url}
      alt={alt}
      className="img-fluid"
      key={`image_url_${key}`}
    />
  ));
  const thumbnails = [...slides];
  if (videos && videos.length > 0) {
    const videoSlides = videos.map((video_id) => (
      <iframe
        width="500"
        height="281"
        src={`https://www.youtube.com/embed/${video_id}`}
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen
      ></iframe>
    ));
    const videoThumbnails = videos.map((video_id, key) => (
      <img
        src={`https://img.youtube.com/vi/${video_id}/mqdefault.jpg`}
        alt={alt}
        className="img-fluid"
        key={`image_url_${key}`}
      />
    ));
    slides.push(...videoSlides);
    thumbnails.push(...videoThumbnails);
  }
  return (
    <div className="images">
      <Carousel value={active_image} slides={slides} onChange={handleImage} />
      {images.length > 1 && (
        <Dots
          number={slides.length}
          thumbnails={thumbnails}
          value={active_image}
          onChange={handleImage}
        />
      )}
    </div>
  );
};

const Pricing = ({ prices, unit }) => {
  const discount = prices.regular
    ? priceDiscountValue(prices.regular, prices.main)
    : false;
  return (
    <div className="pricing">
      <h2>
        {prices.regular && (
          <div>
            <span className="line">${prices.regular}</span>{' '}
            <span> ({discount} de descuento)</span>
          </div>
        )}
        {prices.main > 0 ? `$${formatNumber(prices.main)}` : '-'}
        <span className="unit">/{unit}</span>
      </h2>
    </div>
  );
};
const Desc = ({ product }) => {
  const location = JSON.parse(localStorage.getItem('location') || '{}');
  return (
    <div className="desc">
      <p>
        <Link to={`/marca/${product.aliasd}`}>{product.aliasd}</Link>
      </p>
      <h1>{product.descp1}</h1>
      <Raiting rating={product.rating} />
      {product.description && (
        <p className="long-desc">{product.description}</p>
      )}
      {location.id === '0' && product.shipping !== 'Nacional' ? (
        <p className="text-danger">
          Este producto no se puede enviar a tu locación
        </p>
      ) : null}
    </div>
  );
};

const Raiting = ({ rating }) => {
  const rating_value = rating ? rating.value : 0; ///1 to 5
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    stars.push(
      <i
        className={`${i <= rating_value ? 'fas' : 'far'} fa-star`}
        key={`stars_${i}`}
      ></i>
    );
  }
  if (!rating) return null;
  return (
    <div className="rating d-flex small e">
      <div className="text-warning mr-2">{stars}</div>
      <span className="text-muted">
        ({rating.cant > 1 ? `${rating.cant} valoraciones` : '1 valoración'})
      </span>
    </div>
  );
};
const ProductSection = ({
  product,
  promptAdd,
  amount,
  current_amount,
  handleAmount,
  handleImage,
  active_image,
  onUpdate,
}) => {
  const currentLocation = JSON.parse(localStorage.getItem('location'));
  const stock = product.zoneAvail.find(
    (item) => item.xiaz_id === currentLocation.id
  );
  const hasStockAnywhere = hasAvailableStock(
    product.zoneAvail,
    currentLocation.id
  );
  const [localBranchNames, setLocalBranchNames] = useState([]);

  const inquiryText = `Hola, tengo una pregunta sobre el producto:\n\nProducto: ${product.descp1}\nID: ${product.idpart}\nURL: http://mathasa.mx/product/${product.id}\n\nMi pregunta:\n`;
  const inquiryWhatsapp = `https://wa.me/526141911212?text=${encodeURIComponent(inquiryText)}`;

  useEffect(() => {
    if (!stock || stock.cantex <= 0) return;
    db.collection('warehouse')
      .get()
      .then((snapshot) => {
        const zone = snapshot.docs
          .map((doc) => doc.data())
          .find((z) => z.id === currentLocation.id);
        if (zone && zone.xiams) {
          setLocalBranchNames(
            zone.xiams
              .filter((b) => b.status !== false && b.descrp)
              .map((b) => b.descrp)
          );
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="row product">
      <div className="col-md-6 position-relative h-min-content">
        {product.icon && (
          <div>
            {['tl', 'tr', 'bl', 'br'].map(
              (position) =>
                product.icon[position] && (
                  <img
                    key={position}
                    src={product.icon[position]}
                    className={`icon icon-${position} ${
                      product.images.length === 1 ? 'bottom' : ''
                    }`}
                    alt="discount_img"
                  />
                )
            )}
          </div>
        )}
        <Images
          idpart={product.idpart}
          handleImage={handleImage}
          active_image={active_image}
          alt={product.descp1}
          images={product.images}
        />
      </div>
      <div className="col-md-6 right">
        <Desc product={product} />
        <Sharebutton
          text="Conoce nuestro producto"
          url={window.location.href}
          title={product.descp1}
        />
        <MercadoPagoModal />
        <Pricing
          prices={{
            main: product.price_num,
            regular: product.price_regular,
          }}
          unit={product.xium ? product.xium.descrp : 'pz'}
        />
        <AddProduct
          promptAdd={promptAdd}
          surface={
            product.xiuds && product.xiuds.length > 0 ? product.xiuds : false
          }
          block
          price={product.price}
          handleAmount={handleAmount}
          amount={amount}
          badge
          current_amount={current_amount}
          onUpdate={onUpdate}
          disabled={!hasStockAnywhere}
        />
        <a
          href={inquiryWhatsapp}
          className="text-decoration-none text-dark btn btn-outline-success btn-block mt-2"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-whatsapp mr-1"></i> Preguntar sobre este producto
        </a>
        {!product.stock && product.price > 0 ? 'Puede tardar en llegar' : null}
        {stock && stock.cantex > 0 ? (
          <span className="text-success d-block my-2 small text-center">
            <i className="fas fa-history fa-flip-horizontal"></i> Recoge en
            tienda en 2 horas
          </span>
        ) : null}
        {stock && stock.cantex > 0 && localBranchNames.length > 0 ? (
          <span className="text-muted d-block my-1 small text-center">
            Recoge en: {localBranchNames.join(', ')}
          </span>
        ) : null}
        {stock && stock.cantex > 0 && stock.cantex <= 10 ? (
          <div>
            <br />{' '}
            <strong className="text-warning d-block my-1 small text-center fw-bold">
              <i className="fas fa-exclamation-triangle"></i> ¡Solo{' '}
              {stock.cantex === 1 ? 'queda' : 'quedan'} {stock.cantex} en
              existencia!
            </strong>
            <br />{' '}
          </div>
        ) : null}
        <table className="table table-striped table-hover w-100 table-sm">
          {product.zoneAvail.map((item, key) => {
            return (
              <tr
                key={`stock_${key}`}
                className={
                  item.xiaz_id === currentLocation.id && 'availability_active'
                }
              >
                <td>{item.xiaz_id ? <b>{item.idzalm}</b> : '-'}</td>
                <td className="text-bold">{item.cantex ? item.cantex : '-'}</td>
              </tr>
            );
          })}
        </table>
      </div>
    </div>
  );
};

export function MercadoPagoModal() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="mp-banner">
        <img src={mplogo} alt="Mercado Pago" height="18" />
        <span className="mp-banner__text">
          <strong>Compra ahora y paga después</strong> con Mercado Pago.{' '}
          <span className="mp-banner__link" onClick={() => setOpen(true)}>
            <br />
            saber más
          </span>
        </span>
      </div>

      {open && (
        <div className="mp-modal-overlay" onClick={() => setOpen(false)}>
          <div className="mp-modal" onClick={(e) => e.stopPropagation()}>
            <button className="mp-modal__close" onClick={() => setOpen(false)}>
              ×
            </button>

            <div className="mp-modal__illustration">
              <PhoneIllustration />
            </div>

            <h2 className="mp-modal__title">
              Compra ahora y paga a meses sin tarjeta de crédito
            </h2>

            {[
              {
                n: 1,
                text: (
                  <>
                    Agrega tu producto al carrito y{' '}
                    <strong>elige pagar con Meses sin Tarjeta.</strong>
                  </>
                ),
              },
              {
                n: 2,
                text: (
                  <>
                    En tu cuenta de Mercado Pago,{' '}
                    <strong>elige la cantidad de meses</strong> y confirma.
                  </>
                ),
              },
              {
                n: 3,
                text: (
                  <>
                    <strong>Paga mes a mes</strong> con saldo disponible, débito
                    u otros medios.
                  </>
                ),
              },
            ].map(({ n, text }, arr) => (
              <div key={n} className="mp-modal__step">
                <div className="mp-modal__step-indicator">
                  <div className="mp-modal__step-number">{n}</div>
                  {n < 3 && <div className="mp-modal__step-line" />}
                </div>
                <p className="mp-modal__step-text">{text}</p>
              </div>
            ))}

            <p className="mp-modal__disclaimer">Crédito sujeto a aprobación.</p>
            <p className="mp-modal__help">
              ¿Tienes dudas? Consulta nuestra{' '}
              <a
                href="https://www.mercadopago.com.mx/ayuda/19040"
                target="_blank"
                rel="noopener noreferrer"
              >
                Ayuda
              </a>
              .
            </p>
          </div>
        </div>
      )}
    </>
  );
}

export default ProductSection;
